import React from "react";
import { ReactComponent as Icon } from "../files/Facebook.svg";
import ISVGIconProps from "../ISVGIconProps";

const FacebookIcon = ({
    fill,
    style = {},
    className = "",
}: ISVGIconProps) => {
    return <Icon className={className} fill={fill} style={style} />;
};

export default FacebookIcon;
